export default "__VITE_ASSET__Dn029kgE__"